import { useCallback, useState } from 'react';
export function useToggle(initialState) {
    if (initialState === void 0) { initialState = false; }
    var _a = useState(initialState), state = _a[0], setState = _a[1];
    var setTrue = useCallback(function () { return setState(true); }, []);
    var setFalse = useCallback(function () { return setState(false); }, []);
    var toggle = useCallback(function () { return setState(function (currentState) { return !currentState; }); }, []);
    return [state, setTrue, setFalse, toggle];
}
//# sourceMappingURL=useToggle.js.map